<template>
  <div class="mx-4 my-2">
    <div>

      <table id="device-list" class="display" :key="tableKey">
        <thead>
        <tr>
          <th>{{$t('name')}}</th>
          <th>{{$t('serial')}}</th>
          <th>{{$t('type')}}</th>
          <th>{{$t('network')}}</th>
          <th>{{$t('state')}}</th>
          <th>{{$t('last_position')}}</th>
          <th>{{$t('subscription_state')}}</th>
          <th>{{$t('subscription_end_date')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in devices" :key="item.serial">
          <td @click="select_device(item)" class="font-weight-bold text-primary td-link">{{ item.name }}</td>
          <td>{{ item.serial }}</td>
          <td>{{ fmtType(item)}}</td>
          <td>
            <div v-if="item.tracker_config">{{ item.tracker_config.network }}</div>
          </td>
          <td>{{ item.tracker_status.state}}</td>
          <td>{{ formatDateForSorting(item.tracker_status.last_location)}}</td>
          <td>{{ item.tracker_status.sub_state}}</td>
          <td>{{ item.tracker_status.sub_end_date}}</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div id="deviceModal"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         aria-labelledby="deviceModalLabel"
         aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deviceModalLabel">{{$t('tracker_details')}}</h5>
            <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close2"
                @click="reloadPage"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <TrackerDetail v-if="selectedDevice" :device="selectedDevice" @exit-component="reloadPage"/>
          </div>
          <div class="modal-footer">
            <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
                @click="closeModal"
            >
              {{$t('close')}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.min.css';
import * as nvxlib from "@/nvxcommon";
import TrackerDetail from "./TrackerDetail.vue";

import languageFR from 'datatables.net-plugins/i18n/fr-FR.mjs';
import languageEN from 'datatables.net-plugins/i18n/en-GB.mjs';

export default {
  components: {
    TrackerDetail,
  },
  data() {
    return {
      isModalOpen: false, // Modal visibility
      selectedDevice: null, // Currently selected device
      devices: [],
      tableKey: 0,
      table: null
    };
  },
  computed: {},
  methods: {
    fmtDate(date) {
      return nvxlib.fmtDate(date);
    },
    fmtType(device) {
      return nvxlib.trackerType(device);
    },
    formatDateForSorting(date) {
      return nvxlib.formatDateForSorting(date);
    },
    select_device(device) {
      console.log('select_device', device.serial);
      this.selectedDevice = device;
      this.$nextTick(() => {
        $('#deviceModal').modal('show'); // Show the modal
      });
    },
    closeModal() {
      this.$nextTick(() => {
        $('#deviceModal').modal('hide');
        this.selectedDevice = null; // Reset selected device
      });
    },
    loadTable() {
      console.log("load table");

      nvxlib.getDevices((devices) => {
        console.log("Devices", devices.length);

        this.devices = devices; // Vue updates the DOM

        // Ensure Vue updates before initializing DataTable
        this.$nextTick(() => {
          console.log("Vue has finished updating <tbody>, checking if row is removed...");

          let locale = navigator.language;

          if (this.table) {
            console.log("Destroying existing DataTable");
            this.table.destroy();
            this.table = null;
          }

          this.tableKey += 1;
          this.$nextTick(() => {
            console.log("Init datatable: ", locale);
            let language = locale === 'fr-FR' ? languageFR : languageEN;
            this.table = $("#device-list").DataTable({
              language: language,
              searching: true,
              ordering: true,
              pagingType: "full_numbers",
              pageLength: 50,
            });
          });
        });
      });
    },
    reloadPage() {
      this.closeModal();

      this.$nextTick(() => {
        this.loadTable(); // Fetch new data and reinitialize DataTable
      });

    }
  },
  mounted() {
    this.loadTable();
  },
};

</script>
